<!--Header Start-->
<header id="rs-header" class="rs-header">
  <!-- Menu Start -->
  <!-- Topbar Area Start -->
  <top-bar></top-bar>
  <!-- Topbar Area End -->
  <div class="menu-area menu-sticky">
    <div class="container">
      <div class="row y-middle">
        <div class="col-lg-2">
          <div class="logo-cat-wrap">
            <div class="logo-part">
              <a href="/">
                <img class="normal-logo" src="assets/college/sapthagiridegreecollege.png" alt="Sapthagiri Degree & P.G College">
                <img class="sticky-logo" src="assets/college/sapthagiridegreecollege.png" alt="Sapthagiri Degree & P.G College">
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-9 text-right">
          <div class="rs-menu-area">
            <div class="main-menu">
              <div class="mobile-menu">
                <a class="rs-menu-toggle">
                  <i class="fa fa-bars"></i>
                </a>
              </div>
              <nav class="rs-menu">
                <ul class="nav-menu">
                  <li class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a routerLink="/">Home</a>
                  </li>
                  <li class="menu-item-has-children" routerLinkActive="active">
                    <a>About</a>
                    <ul class="sub-menu">
                      <li><a routerLink="/about/college" routerLinkActive="active">College</a></li>
                      <li><a routerLink="/about/management" routerLinkActive="active">Management</a></li>
                      <li><a routerLink="/about/sri-balaji-educational-society" routerLinkActive="active">Sri Balaji Educational Society</a></li>
                      <li><a routerLink="/about/balaji-sevasamithi" routerLinkActive="active">Balaji SevaSamithi</a></li>
                      <li><a routerLink="/about/balaji-insurance" routerLinkActive="active">Balaji Insurance</a></li>
                      <li><a routerLink="/about/principal" routerLinkActive="active">Principal</a></li>
                    </ul>
                  </li>
                  <li class="menu-item-has-children" routerLinkActive="active">
                    <a>Academics</a>
                    <ul class="sub-menu">
                      <li><a routerLink="/academics/disciplines-and-departments" routerLinkActive="active">Disciplines & Departments</a></li>
                      <li><a routerLink="/academics/courses-offered-and-admissions" routerLinkActive="active">Courses Offered & Admissions</a></li>
                      <li><a routerLink="/academics/college-fee" routerLinkActive="active">College Fee</a></li>
                      <li><a routerLink="/academics/scholarships" routerLinkActive="active">Scholarships</a></li>
                      <li><a routerLink="/academics/financial-aid" routerLinkActive="active">Financial Aid</a></li>
                      <li><a routerLink="/academics/curriculum" routerLinkActive="active">Curriculum</a></li>
                      <li><a routerLink="/academics/academic-calender" routerLinkActive="active">Academic Calender</a></li>
                      <li><a routerLink="/academics/quality-parameters" routerLinkActive="active">Quality Parameters</a></li>
                      <li><a routerLink="/academics/any-others" routerLinkActive="active">Any Others</a></li>
                    </ul>
                  </li>
                  <li class="menu-item-has-children" routerLinkActive="active">
                    <a>Faculty</a>
                    <ul class="sub-menu">
                      <li><a routerLink="/faculty/departments" routerLinkActive="active">Departments</a></li>
                      <li><a routerLink="/faculty/teaching-and-nonteaching" routerLinkActive="active">Teaching & Non-Teaching</a></li>
                      <li><a routerLink="/faculty/profile" routerLinkActive="active">Profile</a></li>
                      <li><a routerLink="/faculty/publications" routerLinkActive="active">Publications</a></li>
                      <li><a routerLink="/faculty/research" routerLinkActive="active">Research</a></li>
                      <li><a routerLink="/faculty/achievements" routerLinkActive="active">Achievements</a></li>
                      <li><a routerLink="/faculty/any-others" routerLinkActive="active">Any Others</a></li>
                    </ul>
                  </li>

                  <li class="menu-item-has-children" routerLinkActive="active">
                    <a>Infrastructure</a>
                    <ul class="sub-menu">
                      <li><a routerLink="/infra/campus-buildings" routerLinkActive="active">Campus Buildings</a></li>
                      <li><a routerLink="/infra/library" routerLinkActive="active">Library</a></li>
                      <li><a routerLink="/infra/labs" routerLinkActive="active">Labs</a></li>
                      <li><a routerLink="/infra/play-ground" routerLinkActive="active">Play Ground</a></li>
                      <li><a routerLink="/infra/hostel" routerLinkActive="active">Hostel</a></li>
                      <li><a routerLink="/infra/events" routerLinkActive="active">Events</a></li>
                      <li><a routerLink="/infra/sports" routerLinkActive="active">Sports</a></li>
                      <li><a routerLink="/infra/transport-and-parking" routerLinkActive="active">Transport & Parking</a></li>
                      <li><a routerLink="/infra/any-others" routerLinkActive="active">Any Others</a></li>
                    </ul>
                  </li>
                  <li class="menu-item-has-children" routerLinkActive="active">
                    <a>Committees</a>
                    <ul class="sub-menu">
                      <li><a routerLink="/anti-ragging-committee" routerLinkActive="active">Anti Ragging Committee</a></li>
                      <li><a routerLink="/grievance-reddressal-committee" routerLinkActive="active">Grievance Reddressal Committee</a></li>
                      <li><a routerLink="/internal-complaints-committee" routerLinkActive="active">Internal Complaints Committee</a></li>
                      <li><a routerLink="/sc-and-st-grievance-committee" routerLinkActive="active">SC & ST Grievance Committee</a></li>
                      <li><a routerLink="/internal-quality-assurance-committee" routerLinkActive="active">Internal Quality Assurance Committee</a></li>
                      <li><a routerLink="/institution-industry-cell" routerLinkActive="active">Institution Industry Cell</a></li>
                    </ul>
                  </li>

                  <!--<li class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a routerLink="/gallery">Gallery</a>
                  </li>-->
                  <li class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a routerLink="/contact">Contact</a>
                  </li>
                </ul>
              </nav>
            </div> <!-- //.main-menu -->
          </div>
        </div>
        <div class="col-lg-1 text-right">
          <div class="expand-btn-inner">

            <a id="nav-expander" class="nav-expander style6">
              <span class="dot1"></span>
              <span class="dot2"></span>
              <span class="dot3"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Menu End -->
  <nav class="right_menu_togle hidden-md">
    <div class="close-btn">
      <div id="nav-close">
        <div class="line">
          <span class="line1"></span><span class="line2"></span>
        </div>
      </div>
    </div>
    <div class="canvas-logo">
      <a href="index.html"><img src="assets/college/sapthagiridegreecollege.png" alt="Sapthagiri Degree & P.G College"></a>
    </div>
    <div class="offcanvas-text">
      <p>We denounce with righteous indige nationality and dislike men who are so beguiled and demo  by the charms of pleasure of the moment data com so blinded by desire.</p>
    </div>
    <div class="offcanvas-gallery">
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/1.jpg"><img src="assets/images/gallery/1.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/2.jpg"><img src="assets/images/gallery/2.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/3.jpg"><img src="assets/images/gallery/3.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/4.jpg"><img src="assets/images/gallery/4.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/5.jpg"><img src="assets/images/gallery/5.jpg" alt=""></a>
      </div>
      <div class="gallery-img">
        <a class="image-popup" href="assets/images/gallery/6.jpg"><img src="assets/images/gallery/6.jpg" alt=""></a>
      </div>
    </div>
    <div class="map-img">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3874.1433725620195!2d77.484444!3d13.830428099999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb1a39b75d11221%3A0xf65be1ea7fe1c652!2sSapthagiri%20college!5e0!3m2!1sen!2sin!4v1777465231386!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>    </div>

    <div class="canvas-contact">
      <ul class="social">
        <li><a href="#"><i class="fa fa-facebook"></i></a></li>
        <li><a href="#"><i class="fa fa-twitter"></i></a></li>
        <li><a href="#"><i class="fa fa-pinterest-p"></i></a></li>
        <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
      </ul>
    </div>
  </nav>
</header>
<!--Header End-->
